module.exports = __webpack_public_path__ + "static/corpse_flower-16256407ca22a434bbc3bb1fd1a6bd7b.png";